module.exports = __webpack_public_path__ + "media/images/xc_6-7fd77d71706e0961314d426457e452cb.png";